import { useCallback, useState } from "react";

type SideNavState = "mini" | "wide";

const COOKIE_NAME = "side-navigation-state";

const readCookie = (): SideNavState => {
  const match = document.cookie
    .split("; ")
    .find((row) => row.startsWith(COOKIE_NAME + "="));
  const value = match?.split("=")[1];
  return value === "mini" ? "mini" : "wide";
};

const writeCookie = (value: SideNavState): void => {
  document.cookie = `${COOKIE_NAME}=${value}; path=/; max-age=31536000`;
};

export const useSideNavState = () => {
  const [state, setState] = useState<SideNavState>(readCookie);

  const toggle = useCallback(() => {
    setState((prev) => {
      const next: SideNavState = prev === "wide" ? "mini" : "wide";
      writeCookie(next);
      return next;
    });
  }, []);

  const set = useCallback((value: SideNavState) => {
    writeCookie(value);
    setState(value);
  }, []);

  return { state, toggle, set };
}
